<template>
  <SgImg
    :do-not-lazy-load="!lazyLoad"
    :src="url"
    :placeholder-ratio="placeholderRatio"
    :width="width"
    :height="height"
    alt="Product Image"
    v-bind="$attrs"
    @load="$emit('loaded')"
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    sku: { type: String, required: true },
    secondarySku: { type: String, default: null },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 400 },
    bg: { type: String, default: 'f2f2f5' },
    viewAngle: { type: Number, default: 5 },
    frame: { type: Number, default: null },
    scale: { type: Number, default: 1.4 },
    lazyLoad: { type: Boolean, default: false },
    placeholderRatio: { type: String, default: '' },
    noCropAdjust: { type: Boolean, default: false },
    cropFactor: { type: Number, default: null },
  },

  emits: ['loaded'],
  
  computed: {
    url() {
      return this.buildUrl()
    },
  },

  methods: {
    buildUrl(options = {}) {
      options = {
        ...options,
        sku: options.sku ?? this.sku,
        secondarySKU: options.secondarySku ?? this.secondarySku,
        width: options.width ?? this.width,
        height: options.height ?? this.height,
        bg: options.bg ?? this.bg,
        image_number: options.viewAngle ?? this.viewAngle,
        scale: Math.min(options.scale ?? this.scale, 1.7),
      }
      if (this.noCropAdjust) options.no_crop_adjust = true
      if (this.cropFactor) options.crop_factor = this.cropFactor
      if (this.frame) options.frame = this.frame

      return useProductImageURL(options)
    },
  },
}
</script>
